"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.petHealth_enDe = void 0;
exports.petHealth_enDe = {
    metaData: {
        prismicId: 'ZofUgxEAACsAgzqm',
        type: 'comparisontable',
        uid: 'pet-health',
        lang: 'en-de',
        lastPublished: '2024-07-26T14:55:48+0000',
    },
    tableData: {
        title: 'Pet Health',
        collapsibleSections: false,
        hideDetails: false,
        tableData: [
            {
                section: {
                    title: '',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$ff84d42e-0ccb-43f6-896b-e0e4322b3870_header',
                            text: 'Our plans',
                            description: null,
                        },
                        {
                            cellId: 'table_row$ff84d42e-0ccb-43f6-896b-e0e4322b3870_0',
                            type: 'BUTTON',
                            buttonCaption: 'Surgery',
                            disabled: true,
                        },
                        {
                            cellId: 'table_row$ff84d42e-0ccb-43f6-896b-e0e4322b3870_1',
                            type: 'BUTTON',
                            buttonCaption: 'Standard',
                            disabled: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$d5490f24-6ae6-4d0d-9eae-d074daed1419_header',
                            text: 'Regular vet visits & medication',
                            description: 'including telemedicine',
                        },
                        {
                            cellId: 'table_row$d5490f24-6ae6-4d0d-9eae-d074daed1419_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$d5490f24-6ae6-4d0d-9eae-d074daed1419_1',
                            description: 'up to €800 per insured year',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$066cabd3-663b-4bfe-bb4b-3953d1613651_header',
                            text: 'Operations',
                            description: null,
                        },
                        {
                            cellId: 'table_row$066cabd3-663b-4bfe-bb4b-3953d1613651_0',
                            description: 'no annual limit',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$066cabd3-663b-4bfe-bb4b-3953d1613651_1',
                            description: 'no annual limit',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$558543ad-985a-4722-8259-03e49cd17950_header',
                            text: 'Dental',
                            description: 'checkups, tooth replacements, inlays, fillings',
                        },
                        {
                            cellId: 'table_row$558543ad-985a-4722-8259-03e49cd17950_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$558543ad-985a-4722-8259-03e49cd17950_1',
                            description: 'up to €150 per insured year',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$54024c29-2b22-4ea7-8283-d7efd9ce57b5_header',
                            text: 'Preventive treatments',
                            description: 'vaccinations, deworming, flea & tick repellants',
                        },
                        {
                            cellId: 'table_row$54024c29-2b22-4ea7-8283-d7efd9ce57b5_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$54024c29-2b22-4ea7-8283-d7efd9ce57b5_1',
                            description: 'up to €70 per insured year',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$47b3865e-6d4b-4dcc-8575-2a88d591db42_header',
                            text: 'Castration/sterlization (voluntary/precautionary)',
                            description: 'covered under preventive treatments',
                        },
                        {
                            cellId: 'table_row$47b3865e-6d4b-4dcc-8575-2a88d591db42_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$47b3865e-6d4b-4dcc-8575-2a88d591db42_1',
                            description: 'up to €70 per insured year',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6201c110-4d99-4ca8-8eba-a657f5732e28_header',
                            text: 'Physiotherapy',
                            description: null,
                        },
                        {
                            cellId: 'table_row$6201c110-4d99-4ca8-8eba-a657f5732e28_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$6201c110-4d99-4ca8-8eba-a657f5732e28_1',
                            description: 'up to 10 30-minute sessions per insured year',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$de7d8876-a8df-4dd6-bbc1-f6da6ecea4d2_header',
                            text: 'General waiting period',
                            description: 'no waiting period for treatments after an accident',
                        },
                        {
                            cellId: 'table_row$de7d8876-a8df-4dd6-bbc1-f6da6ecea4d2_0',
                            text: '1 month',
                        },
                        {
                            cellId: 'table_row$de7d8876-a8df-4dd6-bbc1-f6da6ecea4d2_1',
                            text: '1 month',
                            description: 'no waiting period for preventive treatments',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$c104905e-387c-4078-85fd-962aae97b966_header',
                            text: 'Special waiting period',
                            description: 'hip dysplasia, eyelid correction, medically necessary castration/sterlization',
                        },
                        {
                            cellId: 'table_row$c104905e-387c-4078-85fd-962aae97b966_0',
                            text: '6 to 18 months',
                        },
                        {
                            cellId: 'table_row$c104905e-387c-4078-85fd-962aae97b966_1',
                            text: '6 to 18 months',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$f3455b1b-e099-43c4-ba87-26c84fafa4dd_header',
                            text: 'Pre-existing conditions, operations and treatments before the end of the waiting period',
                            description: null,
                        },
                        {
                            cellId: 'table_row$f3455b1b-e099-43c4-ba87-26c84fafa4dd_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$f3455b1b-e099-43c4-ba87-26c84fafa4dd_1',
                            checkmarkValue: false,
                        },
                    ],
                ],
            },
        ],
    },
};
